import classNames from 'classnames';
// import PropTypes from 'prop-types';
import {SubMenu as RcSubMenu} from 'rc-menu/es';
import omit from 'rc-util/es/omit';
import * as React from 'react';
import {WebUI, getNid} from "../../wui-core/src/index"
import MenuContext from './config-provider/MenuContext';
import { SubMenuProps } from './iMenu';

const defaultProps = {
    disabled: false, // 是否禁用
    icon: undefined, // 菜单图标
    // popupClassName: '', // 子菜单样式，mode="inline" 时无效
    // title: '', // 子菜单项值
    popupOffset: [0, 5] as [number, number], // 子菜单偏移量，mode="inline" 时无效
    // onTitleClick: null, // 点击子菜单标题
}

const SubMenu: React.FC<SubMenuProps> = (props) => {
    const context = React.useContext(MenuContext);
    const { menuTheme, mode, arrowdown, firstLevel, inlineCollapsed } = context;
    const { clsPrefix, popupClassName, className, icon, title } = props;

    const renderTitle = React.useCallback(() => {
        if (!icon) {
            return inlineCollapsed && firstLevel && title && typeof title === 'string' ? (
                <div className={`${clsPrefix}-inline-collapsed-noicon`}>{title}</div>
            ) : (
                title
            );
        }
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        const titleIsSpan = React.isValidElement(title) && title.type === 'span';
        return (
            <>
                {icon}
                {titleIsSpan ? title : <span>{title}</span>}
            </>
        );
    }, [inlineCollapsed, firstLevel, title, icon, clsPrefix]);

    const titleNode = renderTitle();
    let adapterNid = getNid(props);
    let { popupOffset } = context;
    // 第一级采用传过来的，其他默认
    if (!firstLevel) {
        popupOffset = [0, 5];
    }

    return (
        <MenuContext.Provider
            value={{
                ...context,
                firstLevel: false,
            }}
        >
            <RcSubMenu
                {...omit(props, ['icon', 'clsPrefix', 'popupClassName', 'dir'])}
                title={titleNode}
                className={classNames(
                    {[`${clsPrefix}-submenu-arrowdown`]: (mode === 'horizontal' && arrowdown)},
                    className
                )}
                popupOffset={popupOffset || props.popupOffset}
                popupClassName={classNames(
                    clsPrefix,
                    `${clsPrefix}-${menuTheme}`,
                    popupClassName,
                )}
                {...adapterNid}
            />
        </MenuContext.Provider>
    );
};

// 添加静态属性和默认属性
(SubMenu as any).defaultProps = defaultProps;
(SubMenu as any).isSubMenu = true;

// 使用装饰器导出
const SubMenuWithDecorators = WebUI({name: "menu", defaultProps})(SubMenu);

export default SubMenuWithDecorators;
